import { useEffect, useState } from "react";
import { loadProductCategories } from "@/lib/productCategories";

/**
 * Real catalogue data for the homepage "Explore by Category" section — nothing is invented or hard-coded:
 * the product categories from Admin → Mega Menu that actually contain at least one published product (checked with a
 * 1-item query per category, ~1KB each, instead of downloading the whole product list). Each carries `sample`, its first
 * product, used as an image fallback.
 *
 * (The "Product Solutions" cards are NOT built here any more: they are the products chosen in Admin → Home Page and are
 * read by hooks/useFeaturedProducts.js. This hook used to also fetch up to 50 featured products and test-load every one of
 * their images on every visit — a result nothing displayed, and a network race that could change from one load to the next.)
 */
export default function useHomeCatalogue() {
  const [state, setState] = useState({ loading: true, categories: [] });

  useEffect(() => {
    let alive = true;
    loadProductCategories()
      .then((categories) => { if (alive) setState({ loading: false, categories }); })
      .catch(() => { if (alive) setState({ loading: false, categories: [] }); });
    return () => { alive = false; };
  }, []);

  return state;
}
